import { render, staticRenderFns } from "./product-inventory.vue?vue&type=template&id=c86f346a&scoped=true&"
import script from "./product-inventory.vue?vue&type=script&lang=ts&"
export * from "./product-inventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f346a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCheckbox,VContainer,VSpacer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c86f346a')) {
      api.createRecord('c86f346a', component.options)
    } else {
      api.reload('c86f346a', component.options)
    }
    module.hot.accept("./product-inventory.vue?vue&type=template&id=c86f346a&scoped=true&", function () {
      api.rerender('c86f346a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/views/product-inventory.vue"
export default component.exports